"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZAutoComplete = void 0;
const React = __importStar(require("react"));
const ReactDOM = __importStar(require("react-dom"));
const _ = __importStar(require("lodash"));
const AppContext_1 = require("../../utils/AppContext");
const kendo_react_dropdowns_1 = require("@progress/kendo-react-dropdowns");
const kendo_data_query_1 = require("@progress/kendo-data-query");
const core_1 = require("../../utils/core");
const utils_1 = require("../../utils");
const __1 = require("../");
const icons_1 = require("../../icons");
const utils_2 = require("../../utils/utils");
const kendo_react_common_1 = require("@progress/kendo-react-common");
const ll_1 = require("../../languages/ll");
const kendo_react_intl_1 = require("@progress/kendo-react-intl");
const useFetch_1 = require("../../apis/useFetch");
const useLocalizedProps_1 = require("../../languages/useLocalizedProps");
const styled_components_1 = __importDefault(require("styled-components"));
const ZAutoCompleteComponent = (props) => {
    const { languageId, ...localizedProps } = useLocalizedProps_1.useLocalizedProps(props);
    const { value, textField, placeholder, defaultValue, className, disabled, required } = localizedProps;
    let { loading } = localizedProps;
    const { opened, setOpened, currentText, setCurrentText } = props;
    const debouncedText = utils_1.useDebounce((currentText || "").trim(), 200);
    const [searchPopupOpen, setSearchPopupOpen] = React.useState(false);
    const [raisedLabel, setRaisedLabel] = React.useState(value || placeholder || defaultValue ? true : false);
    const { isMobile } = React.useContext(AppContext_1.AppContext);
    const columnsToShow = isMobile && props.mobileColumns ? "mobileColumns" : "columns";
    let data = props.data || [];
    const componentRef = React.useRef(null);
    const filterData = React.useCallback((filterText) => {
        if (!filterText) {
            return data;
        }
        const fieldsToSearch = _.union([textField], (props.columns || []).map(c => c.field)).filter(f => !!f);
        const filters = fieldsToSearch
            .map(field => {
            return field
                ? {
                    value: filterText,
                    field,
                    operator: "contains",
                    ignoreCase: true
                }
                : undefined;
        })
            .filter(f => !!f);
        return kendo_data_query_1.filterBy(data, {
            logic: "or",
            filters: filters
        });
    }, [data, props.columns, textField]);
    const spanId = React.useRef("ZAutoComplete-" + kendo_react_common_1.guid());
    const headerRow = React.useMemo(() => (localizedProps[columnsToShow] || []).map((column, index) => {
        return (React.createElement("span", { key: `grid-cell-${index}`, className: "autocomplete-grid-header-cell" }, props.localize === false
            ? column.title || column.field
            : ll_1.ll({ key: column.title || column.field, languageId })));
    }), [columnsToShow, languageId, localizedProps, props.localize]);
    React.useEffect(() => {
        setRaisedLabel((props.value
            ? true
            : componentRef &&
                componentRef.current &&
                componentRef.current.state.focused == true) || false);
    }, [props.value]);
    React.useEffect(() => {
        const comboBox = componentRef && componentRef.current;
        const field = comboBox &&
            comboBox.element &&
            comboBox.element.firstChild &&
            comboBox.element.firstChild &&
            comboBox.element.firstChild.firstChild;
        const handler = (event) => {
            if (event.keyCode === 13) {
                setOpened(true);
            }
        };
        field && field.addEventListener("keypress", handler);
        return () => {
            field && field.removeEventListener("keypress", handler);
        };
    }, [opened, setOpened]);
    React.useEffect(() => {
        const eventListener = {
            handleEvent: e => {
                if (e.target.closest(`#${spanId.current}`) === null) {
                    setOpened(false);
                }
            }
        };
        window.addEventListener("click", eventListener);
        return () => {
            window.removeEventListener("click", eventListener);
        };
    }, [setOpened]);
    const defaultColumns = React.useMemo(() => [{ field: props.textField || "" }], [props.textField]);
    const columns = localizedProps[columnsToShow] || defaultColumns;
    const frameContext = React.useContext(utils_1.FrameContext);
    return (React.createElement("span", { id: props.id },
        React.createElement(__1.RequiredDot, { required: required, raised: raisedLabel, raisedTransform: "down-9 right-4", loweredTransform: "down-26 left-1" },
            React.createElement("span", { id: spanId.current, className: [
                    className,
                    "z-component z-autocomplete",
                    disabled ? "disabled" : ""
                ].join(" ") },
                React.createElement("span", { className: className, onClick: event => {
                        if (disabled)
                            return;
                        if (event.nativeEvent.target.matches(".k-i-close")) {
                            if (componentRef.current &&
                                !componentRef.current.state.focused) {
                                setRaisedLabel(false);
                            }
                            else {
                                localizedProps.onChange &&
                                    localizedProps.onChange({
                                        target: { value: null }
                                    }, undefined);
                                setRaisedLabel(true);
                            }
                        }
                        else {
                            setOpened(!opened);
                        }
                    } },
                    React.createElement(kendo_react_dropdowns_1.ComboBox, Object.assign({}, localizedProps, { header: React.createElement("div", { className: "autocomplete-grid-header-row autocomplete-grid-row" }, headerRow), suggest: true, loading: loading, opened: opened, data: filterData(debouncedText), dataItemKey: "Id", itemRender: (item, itemProps) => {
                            const itemChildren = columns.map((column, index) => (React.createElement("span", { key: `grid-cell-${itemProps.index}-${index}`, className: "autocomplete-grid-cell" },
                                React.createElement(core_1.FormattedValue, { value: _.get(itemProps.dataItem, column.field, undefined), format: utils_2.getFormatForField(`${props.entity}.${column.field}`) }))));
                            return React.cloneElement(item, item.props, React.createElement("div", { className: "autocomplete-grid-row" }, itemChildren));
                        }, onClose: event => {
                            setTimeout(() => {
                                setCurrentText("");
                            }, 1000);
                            setOpened(false);
                            localizedProps.onClose && localizedProps.onClose(event);
                        }, onChange: event => {
                            localizedProps.onChange &&
                                localizedProps.onChange(event, event.target.value);
                            setRaisedLabel((event.target.value
                                ? true
                                : componentRef &&
                                    componentRef.current &&
                                    componentRef.current.state.focused == true) ||
                                false);
                        }, onOpen: event => {
                            localizedProps.onOpen && localizedProps.onOpen(event);
                        }, filterable: true, onFilterChange: (event) => {
                            setCurrentText(event.nativeEvent.target.value);
                            setOpened(event.nativeEvent.target.value
                                ? true
                                : false);
                            localizedProps.onFilterChange &&
                                localizedProps.onFilterChange(event);
                        }, onFocus: (event) => {
                            setRaisedLabel(true);
                            localizedProps.onFocus && localizedProps.onFocus(event);
                        }, onBlur: (event) => {
                            setRaisedLabel(event.target.value ? true : false);
                            localizedProps.onBlur && localizedProps.onBlur(event);
                        }, value: value, style: { width: localizedProps.width || 200 }, popupSettings: {
                            className: `${localizedProps.className} autocomplete-popup`,
                            width: `${localizedProps[columnsToShow]
                                ? (localizedProps[columnsToShow] ||
                                    localizedProps.columns ||
                                    []).reduce((prev, curr) => prev + (curr.width || 250), 20)
                                : localizedProps.width || 500}}`
                        } }))),
                localizedProps.searchPopup ? (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: `k-icon search-icon${localizedProps.disabled ? " disabled" : ""}`, onClick: () => {
                            if (!localizedProps.disabled)
                                setSearchPopupOpen(true);
                        } }, icons_1.search),
                    searchPopupOpen
                        ? ReactDOM.createPortal(React.cloneElement(localizedProps.searchPopup, {
                            visible: searchPopupOpen,
                            closeHandler: (event, selectedItem) => {
                                if (!event && !selectedItem) {
                                    setSearchPopupOpen(false);
                                    return;
                                }
                                localizedProps.onChange &&
                                    localizedProps.onChange(event, selectedItem || undefined);
                                setSearchPopupOpen(false);
                            }
                        }, []), frameContext.document.body)
                        : null)) : null))));
};
class AutoComplete extends React.Component {
    constructor(props) {
        super(props);
        this.state = { value: this.props.value || this.props.defaultValue };
    }
    static getDerivedStateFromProps(props, state) {
        return {
            ...state,
            value: props.value
        };
    }
    setValue(value) {
        const valueObject = this.props.data &&
            this.props.data.find(d => d[this.props.dataItemKey || this.props.textField || ""] === value);
        this.setState({
            value: valueObject || value
        });
        this.props.onChange &&
            this.props.onChange({ target: { value: valueObject || value } }, valueObject || value, false);
    }
    render() {
        return (React.createElement(ZAutoCompleteComponent, Object.assign({}, { ...this.props, value: this.state.value || this.props.value })));
    }
}
kendo_react_intl_1.registerForIntl(AutoComplete);
const ZAutoCompleteWrapper = (props) => {
    let { loading, textField, defaultValue, value } = props;
    const [opened, setOpened] = React.useState(false);
    const [currentText, setCurrentText] = React.useState(defaultValue || (textField && value ? value[textField] : value));
    const debouncedText = utils_1.useDebounce(currentText, 200);
    const { isMobile } = React.useContext(AppContext_1.AppContext);
    const columnsToShow = isMobile && props.mobileColumns ? "mobileColumns" : "columns";
    let memoedSelects = React.useMemo(() => {
        let selects = props.textField ? [props.textField] : [];
        let querySelects = [];
        if (props.queryParams && props.queryParams.$select) {
            querySelects = props.queryParams.$select.toString().split(",");
        }
        selects = _.uniq(selects.concat((props[columnsToShow] || props.columns || []).map(c => c.field)));
        if (querySelects) {
            selects = _.uniq(selects.concat(querySelects));
        }
        return selects;
    }, [props, columnsToShow]);
    const memoedExpands = React.useMemo(() => utils_2.getExpandsFromSelects(memoedSelects), [memoedSelects]);
    const getFilterString = React.useCallback((text) => {
        const fieldsToSearch = _.union([props.textField], (props.columns || []).map(c => c.field));
        return __1.getODataSubFilter({
            operator: "multi-contains",
            value: text,
            fields: fieldsToSearch.filter(field => {
                const property = utils_1.getSchemaProperty({
                    entity: props.entity,
                    property: field
                });
                return property && property.Type === "String";
            })
        });
    }, [props.textField, props.entity, props.columns]);
    const params = React.useMemo(() => {
        const filterString = getFilterString(debouncedText);
        return {
            ...props.queryParams,
            $top: props.queryParams ? props.queryParams.$top : 10,
            $select: memoedSelects.join(","),
            $expand: memoedExpands ? memoedExpands.join(",") : undefined,
            $filter: props.queryParams && props.queryParams.$filter
                ? `(${props.queryParams.$filter})${filterString ? " and " + filterString : ""}`
                : debouncedText
                    ? filterString
                    : undefined
        };
    }, [
        props.queryParams,
        memoedSelects,
        memoedExpands,
        getFilterString,
        debouncedText
    ]);
    let { results, pending, error } = useFetch_1.useFetch(params, props.data || !opened ? undefined : props.endpoint || props.entity);
    let data = props.data || results || [];
    if (error) {
        throw error;
    }
    const controlledState = React.useMemo(() => ({ opened, setOpened, currentText, setCurrentText }), [opened, currentText]);
    return (React.createElement(AutoComplete, Object.assign({}, props, controlledState, { loading: loading || pending, data: data, currentText: debouncedText, ref: props.autocompleteRef })));
};
exports.ZAutoComplete = AppContext_1.withAppContext(styled_components_1.default(ZAutoCompleteWrapper) `
      & .autocomplete-grid-header-cell {
         font-weight: bold;
      }
      & .autocomplete-grid-header-row.autocomplete-grid-header-row {
         padding: 2px 24px 2px 24px;
      }
      & .autocomplete-grid-row {
         display: inline-grid;
         column-gap: 5px;
         padding: 5px;
         text-align: left !important;
         grid-template-columns: ${props => {
    const columnsToShow = props.appContext && props.appContext.isMobile
        ? "mobileColumns"
        : "columns";
    return (props[columnsToShow] || props.columns || []).reduce((prev, curr) => prev.concat(` ${curr.width || "auto"}${curr.width ? "px" : ""}`), "");
}};
      }
      & .k-list .k-item.k-state-focused,
      & .k-list .k-item:focus {
         color: ${p => p.theme["action-button-hover-text-color"]};
         background-color: ${p => p.theme["selected-background-color"]};
         &:hover {
            background-color: ${p => p.theme["hover-color"]};
         }
      }
      & .k-list .k-item {
         &:hover {
            color: ${p => p.theme["action-button-hover-text-color"]};
            background-color: ${p => p.theme["hover-color"]};
         }
      }
      &.z-autocomplete {
         padding: 10px;
      }
      &.z-autocomplete > span {
         padding: 0px;
      }
      display: inline-block;

      & .k-label.k-label {
         margin: 0px 3px 1px 5px;
      }
      &.k-combobox {
         border-bottom-color: rgba(0, 0, 0, 0.42);
         &:not(.k-state-invalid):hover {
            background: ${props => !props.disabled && props.theme["input-background-hover-color"]};
         }
      }
      & .k-combobox .k-dropdown-wrap .k-input {
         font-family: ${props => props.theme["font-family"]};
         padding: 0px 24px 0px 5px;
      }
      .k-icon.k-i-arrow-s {
         display: none;
      }
      .k-icon.k-clear-value.k-i-close {
         position: absolute;
         right: ${props => (props.searchPopup ? "16px" : "3px")};
      }
      .k-icon.search-icon {
         position: relative;
         right: 17px;
         top: -1px;
         &:not(.disabled) {
            cursor: pointer;
         }
      }
      .k-icon.search-icon svg {
         color: ${props => props.disabled
    ? props.theme["disabled-color"]
    : props.theme["app-link-color"]};
         opacity: ${props => (props.disabled ? 0.6 : 1.0)};
         &:hover {
            color: ${props => props.disabled
    ? props.theme["disabled-color"]
    : props.theme["hover-color"]};
         }
         &:active {
            color: ${props => props.disabled
    ? props.theme["disabled-color"]
    : props.theme["active-color"]};
         }
      }
   `);
//# sourceMappingURL=ZAutoComplete.js.map